import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const AccountAdjustmentForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [accountOptions, setAccountOptions] = useState([])

    const [formData, setFormData] = useState({
        debit: 0,
        credit: 0,
        date: new Date().toISOString().slice(0, 10),
        remark: "",
        account_id: null,
    })
    const {account_id, debit, credit, remark, date} = formData

    const navigate = useNavigate()

    const loadOptions = async (url, query, setOptions) => {
        try {
            const params = { q: query };

            const response = await Server.get(`/options/${url}`, { params });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {account_id, debit, credit, remark, date}
        addTransaction(payload)
    }
    
    // add account
    const addTransaction = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/account-transations/adjust', payload)
            setIsLoading(false);
            toast.success(response.data?.detail);
            navigate('/cash-balance');
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            if(error.response.status === 401){
                navigate('/login');
            }else if (error.response.status === 422){
                setErrors({});
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Account Adjustment Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="account_id"
                                label="Account"
                                value={account_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('saving-accounts', query, setAccountOptions)}
                                options={accountOptions}
                                placeholder="Start typing to search..."
                                error={errors.account_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="debit"
                                type="number"
                                label="Debit"
                                value={debit}
                                onChange={onChange}
                                error={errors.debit}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="credit"
                                type="number"
                                label="Credit"
                                value={credit}
                                onChange={onChange}
                                error={errors.credit}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <NullableInput
                                placeholder="Remark"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Adjust" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default AccountAdjustmentForm
